import React from 'react';
import ReactDOM from 'react-dom';
import Toasts from '../scomponents/toasts/Toasts';
import Tooltips from '../scomponents/tooltips/Tooltips';
import startEventBackground from '../dom/event-background';
import ProductCategoryApp from "./apps/product-category/ProductCategoryApp";
import DOMCustomEvents, {EVENT_LAYOUT_READY} from "../dom/custom-events/DOMCustomEvents";
import WatchAttributesViewer from "./widgets/watch-attributes-viewer/WatchAttributesViewer";
import WatchWristDemoTool from './tools/watch-wrist-demo/WatchWristDemoTool';
import StrapSelectTool from './tools/strap-select/StrapSelectTool';
import ProductOptionHandler from './handlers/ProductOptionHandler';
import CartHandler from './handlers/CartHandler';
import TabsViewHandler from './handlers/TabsViewHandler';
import ProductGalleryHandler from './handlers/ProductGalleryHandler';
import DiscreteTabsViewHandler from './handlers/DiscreteTabsViewHandler';
import WatchSelectTool from './tools/watch-select/WatchSelectTool';
import WatchFinderApp from './apps/watch-finder/WatchFinderApp';
import PagingPanel from "../components/paging-panel/PagingPanel";
import AboutMapApp from "./apps/about-map/AboutMapApp";
import SubscriptionHandler from "./handlers/SubscriptionHandler";
import Slider from '../../libs/slider';
import {setSessionItem} from "../utils/session-storage";
import ProductFloatActionBar from "./widgets/product-float-action-bar/ProductFloatActionBar";


setSessionItem('locale', 'vi');

Toasts.init();
Tooltips.init();
startEventBackground();


window.TimeLux = {
    unmountComponentAtNode: ReactDOM.unmountComponentAtNode,
    dispatchLayoutReady: () => DOMCustomEvents.dispatch(EVENT_LAYOUT_READY, null),
    renderProductCategoryApp: (el, props) => ReactDOM.render(<ProductCategoryApp {...props}/>, el),
    renderWatchFinderApp: (el, props) => ReactDOM.render(<WatchFinderApp {...props}/>, el),
    renderAboutMapApp: (el, props) => ReactDOM.render(<AboutMapApp {...props}/>, el),
    renderWatchAttributesViewer: (el, props) => ReactDOM.render(<WatchAttributesViewer {...props}/>, el),
    renderWatchWristDemoTool: (el, props) => ReactDOM.render(<WatchWristDemoTool {...props}/>, el),
    renderStrapSelectTool: (el, props) => ReactDOM.render(<StrapSelectTool {...props}/>, el),
    renderWatchSelectTool: (el, props) => ReactDOM.render(<WatchSelectTool {...props}/>, el),
    renderPagingPanel: (el, props) => ReactDOM.render(<PagingPanel {...props}/>, el),
    renderProductFloatActionBar: (el, props) => ReactDOM.render(<ProductFloatActionBar {...props}/>, el),
    ProductOptionHandler: ProductOptionHandler,
    ProductGalleryHandler: ProductGalleryHandler,
    SubscriptionHandler: SubscriptionHandler,
    CartHandler: CartHandler,
    TabsViewHandler: TabsViewHandler,
    DiscreteTabsViewHandler: DiscreteTabsViewHandler,
    Slider: Slider,
};
